import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import Slider from 'react-slick'
import { useMediaQuery } from 'react-responsive'

import ProductCommonContext from '../../../../product/context/common/commonContext'
import CustomCommonContext from '../../../../custom/context/common/commonContext'

const HomePageCarousel = () => {
    const productCommonContext = useContext(ProductCommonContext)
    const customCommonContext = useContext(CustomCommonContext)

    const { setSearchValue } = productCommonContext
    const { allHomeBanner } = customCommonContext

    const isMobile = useMediaQuery({ query: '(max-width:768px)' })

    const settings = {
        dots: true,
        fade: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        speed: 1000,
        autoplaySpeed: 6000,
        cssEase: 'linear',
    }

    const updateFilter = (region = '', color = '') => {
        let searchBarObj = global.initalSearchValues.searchbar
        let searchFilterObj = {
            limit: global.initialPageLimit,
            page: 1,
            orderby: 'p.id, desc',
            order: '',
            filters: {
                searchbar: searchBarObj,
            },
        }
        let searchFilter = ''

        // Assign region to searchbar filter
        if (region) {
            searchFilter = region
        }

        // Assign color to searchbar filter
        if (color) {
            searchFilter = color
        }

        searchFilterObj.filters.searchbar.value = searchFilter

        setSearchValue(searchFilterObj)
    }

    return (
        <div className="heroCarousel">
            <Slider {...settings}>
                {allHomeBanner.map((data, index) => (
                    <>
                        {/* <div
                            key={index}
                            className="sliderCntWrp"
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                height: '539px',
                                flexDirection: data.align_content
                                    ? data.align_content.toLowerCase() === 'left'
                                        ? 'row'
                                        : 'row-reverse'
                                    : 'row',
                            }}
                        > */}
                        {!isMobile ? (
                            <>
                                <div
                                    className="heroContent text-left"
                                    style={{
                                        paddingLeft: data.align_content
                                            ? data.align_content.toLowerCase() === 'left'
                                                ? '16px'
                                                : '30px'
                                            : '16px',
                                    }}
                                >
                                    <p
                                        style={
                                            data?.shadow === 'box shadow'
                                                ? {
                                                      textShadow: '1px 0px 6px #000',
                                                  }
                                                : data?.shadow === 'drop shadow'
                                                ? {
                                                      textShadow: '1px 0px 3px #000',
                                                      filter: 'drop-shadow(2px 3px 6px #222)',
                                                  }
                                                : { textShadow: 'none' }
                                        }
                                    >
                                        {data.title}
                                    </p>
                                    <h1
                                        style={
                                            data?.shadow === 'box shadow'
                                                ? {
                                                      textShadow: '1px 0px 6px #000',
                                                  }
                                                : data?.shadow === 'drop shadow'
                                                ? {
                                                      textShadow: '1px 0px 3px #000',
                                                      filter: 'drop-shadow(2px 3px 6px #222)',
                                                  }
                                                : { textShadow: 'none' }
                                        }
                                    >
                                        {data.description}
                                    </h1>

                                    <Link
                                        to={data.link}
                                        className="brwsMrBtn"
                                        style={{
                                            textShadow:
                                                data?.shadow === 'box shadow'
                                                    ? '1px 0px 6px #000'
                                                    : data?.shadow === 'drop shadow'
                                                    ? '1px 0px 3px #000'
                                                    : 'none',
                                            filter:
                                                data?.shadow === 'drop shadow'
                                                    ? 'drop-shadow(2px 3px 6px #222)'
                                                    : '',
                                            color: data.color ? data.color : '#e1c799',
                                        }}
                                    >
                                        Browse Now{' '}
                                        <span className="material-icons ml-2">chevron_right</span>
                                    </Link>
                                </div>
                                <img
                                    className="bannerImg"
                                    src={`${global.site_url}/uploads/banner/${data.image}`}
                                    alt="Banner"
                                />
                            </>
                        ) : (
                            <Link to={isMobile ? data.link : null}>
                                <div className="heroContent text-left">
                                    <p
                                        style={
                                            data?.shadow === 'box shadow'
                                                ? {
                                                      textShadow: '1px 0px 6px #000',
                                                  }
                                                : data?.shadow === 'drop shadow'
                                                ? {
                                                      textShadow: '1px 0px 3px #000',
                                                      filter: 'drop-shadow(2px 3px 6px #222)',
                                                  }
                                                : { textShadow: 'none' }
                                        }
                                    >
                                        {data.title}
                                    </p>
                                    <h1
                                        style={
                                            data?.shadow === 'box shadow'
                                                ? {
                                                      textShadow: '1px 0px 6px #000',
                                                  }
                                                : data?.shadow === 'drop shadow'
                                                ? {
                                                      textShadow: '1px 0px 3px #000',
                                                      filter: 'drop-shadow(2px 3px 6px #222)',
                                                  }
                                                : { textShadow: 'none' }
                                        }
                                    >
                                        {data.description}
                                    </h1>
                                </div>

                                <img
                                    className="bannerImg"
                                    src={`${global.site_url}/uploads/banner/${
                                        data.image_mobile ? data.image_mobile : data.image
                                    }`}
                                    alt="Banner"
                                />
                            </Link>
                        )}
                        {/* </div> */}
                    </>
                ))}
            </Slider>
        </div>
    )
}

export default HomePageCarousel
